import CognitoCustomerApi from '@lambda/apis/src/customer/cognito';
import { Customer } from '@lambda/apis/src/customer/types';
import settings from '@/settings';
import { logger } from '@/lib/logger';
import {
  COOKIE_COGNITO_ID_TOKEN,
  COOKIE_COGNITO_REFRESH_TOKEN,
} from './useCustomer';

/**
 * The signed-in customer, read server-side from the request's Cognito
 * cookies, or null for a guest (or when the lookup fails).
 */
const fetchCustomerFromCookies = async (
  cookies: Partial<Record<string, string>> | undefined,
): Promise<Customer | null> => {
  const idToken = cookies?.[COOKIE_COGNITO_ID_TOKEN];
  const refreshToken = cookies?.[COOKIE_COGNITO_REFRESH_TOKEN];

  if (!idToken || !refreshToken) {
    return null;
  }

  try {
    return await new CognitoCustomerApi(settings.store).fetchCurrentCustomer(
      idToken,
      refreshToken,
    );
  } catch (error) {
    logger.error({ error }, 'Error fetching customer info');

    return null;
  }
};

export default fetchCustomerFromCookies;
